import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";

function MarketingDetails() {
  const location = useLocation();
  const sessionUserId = sessionStorage.getItem("TRCUserId");

  const [empId, setEmpId] = useState(sessionUserId);
  const [scheduleData, setScheduleData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  console.log("Current empId:", empId); // Debugging

  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(param);
  };

  useEffect(() => {
    const paramEmpId = getQueryParam("id");
    if (paramEmpId) {
      setEmpId(paramEmpId);
    }
  }, []);

  useEffect(() => {
    if (empId) {
      getSchedules();
    }
  }, [empId]); // Now getSchedules() runs only after empId is set

  const getSchedules = async () => {
    try {
      const response = await axios.post(
        "https://api.trucoo.in/marketing/get-schedules/",
        { userId: empId }, // Sending empId in request
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      console.log("API Response:", response.data); // Debugging

      if (response.data.status === "success") {
        setScheduleData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error.response || error.message);
    }
  };

  // Filtering function for date range
  const filteredSchedules = scheduleData.filter((item) => {
    const scheduleDate = new Date(item.schedule.scheduleDate);
    return (
      (!fromDate || scheduleDate >= new Date(fromDate)) &&
      (!toDate || scheduleDate <= new Date(toDate))
    );
  });

  return (
    <>
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <h4 className="box-title">Marketing Schedules</h4>
              </div>

              {/* Date Filter Inputs */}
              <div className="box-body">
                <div className="row">
                  <div className="col-md-4">
                    <label>From Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>To Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {/* Schedules Table */}
              <div className="box-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Action Type</th>
                        <th>Status</th>
                        <th>Remarks</th>
                        <th>Client Name</th>
                        <th>Location</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredSchedules.length > 0 ? (
                        filteredSchedules.map((schedule, index) => (
                          <tr key={index}>
                            <td>{schedule.schedule.date}</td>
                            <td>{schedule.schedule.type}</td>
                            <td>{schedule.schedule.status}</td>
                            <td>{schedule.schedule.remarks || "N/A"}</td>
                            <td>{schedule.client.name}</td>
                            <td>{schedule.client.location}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6}>No schedules found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default MarketingDetails;
